module.exports = __webpack_public_path__ + "img/sportivnye-sertifikaty.1c76ae34.svg";